export default "__VITE_ASSET___IKJlKLR__"